export const SUBHEADER_BACKGROUND_COLOR = "#173C4D";
export const SUBHEADER_TITLE = "Events";
export const MENU_IDS = { EVENTS_OVERVIEW: "eventsOverview", DISCOVER_EVENTS: "discoverEvents", USER_GUIDE: "userGuide" };
export const DEFAULT_ACTIVE_MENU_ID = MENU_IDS.DISCOVER_EVENTS;
export const SUBHEADER_MENU_ITEMS = [
  { id: MENU_IDS.DISCOVER_EVENTS, title: "Discover" },
  { id: MENU_IDS.USER_GUIDE, title: "User Guide" },
];
